import { Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

export default function RenderLineBreak(props) {
  const { elmIndex, elm } = props
  let size = 'h4'
  if (elm.Size === 'Small') size = 'h6'
  else if (elm.Size === 'Large') size = 'h3'
  return <div key={elmIndex}>
    <Typography variant={size}>{elm.Prompt}</Typography>
    {elm.Line && <hr />}
  </div>
}

RenderLineBreak.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
}